/**
 * Совпадает ли медиазапрос — с подпиской на изменение.
 *
 * Приложение одно на все экраны, и почти всё раскладывается средствами CSS.
 * Хук нужен там, где от экрана зависит поведение, а не только вид: шторка на
 * телефоне выезжает снизу и тянется пальцем, на компьютере — это окно.
 */

import { useSyncExternalStore } from 'react';

function supported(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function';
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (!supported()) return () => {};
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    () => supported() && window.matchMedia(query).matches,
    () => false,
  );
}

/** Широкий экран — компьютер или планшет в альбомной ориентации. */
export const DESKTOP_QUERY = '(min-width: 1024px)';

export function useIsDesktop(): boolean {
  return useMediaQuery(DESKTOP_QUERY);
}
